export default  {
    bindings: {
        activeDay: '&',
        source: '<',
        embed: '<',
        times: '=',
        noMessage: '<'
    },
    controller: 'startTimesController',
    template: require('../views/start.times.html')
};
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/start.times.component.js